import _ from 'lodash';
import { evaluateDateRangeExpression, isValidDateRangeExpression } from '@skyjs/date';

export default getQueryExpression => ({
  getPathExpression: (path, value) => {
    if (!isValidDateRangeExpression(value, ['DateTimeRange'])) {
      throw new Error(`Invalid DateTimeRange value: ${value}`);
    }

    const expression = evaluateDateRangeExpression(value, ['DateTimeRange']);
    const criteria = _.isArray(expression)
      ? _.set(
          {},
          '$or',
          expression.map(e => ({ [path.join('.')]: e }))
        )
      : _.set({}, path.join('.'), expression);

    return getQueryExpression(criteria);
  }
});
